<template>
    <div>
        <CCol sm="12">
            <CCard>
                <CCardBody class="d-flex flex-column">
                    <!-- Title -->
                    <h2 class="col-lg-12 text-center mb-3">{{ $t('settings') }}</h2>
                    <!-- Email -->
                    <CRow>
                        <CCol sm="12">
                            <CInput :label="$t('email')" v-model="settings.email" :is-valid="genericValidator(settings.email) && errorValidator('Email')"></CInput>
                        </CCol>
                    </CRow>
                    <!-- Phone -->
                    <CRow>
                        <CCol sm="12">
                            <CInput :label="$t('phone')" v-model="settings.phone" :is-valid="genericValidator(settings.phone) && errorValidator('Phone')"></CInput>
                        </CCol>
                    </CRow>
                    <!-- Facebook -->
                    <CRow>
                        <CCol sm="12">
                            <CInput :label="$t('facebook')" v-model="settings.facebook" :is-valid="genericValidator(settings.facebook) && errorValidator('Facebook')"></CInput>
                        </CCol>
                    </CRow>
                    <!-- Address -->
                    <CRow>
                        <CCol sm="12">
                            <label class=""> {{ $t('address') }}</label>
                            <vue-editor v-model="settings.address" v-bind:class="{'is-invalid': genericValidator(settings.address) == false || errorValidator('Address') }"></vue-editor>
                            <div v-if="errorOutput.Address" class="invalid-feedback">{{errorOutput.Address}}</div>
                        </CCol>
                    </CRow>
                    <!-- Latitude -->
                    <CRow>
                        <CCol sm="12">
                            <CInput :label="$t('latitude')" v-model="settings.latitude" :is-valid="genericValidator(settings.latitude) && errorValidator('Latitude')"></CInput>
                        </CCol>
                    </CRow>
                    <!-- Longitude -->
                    <CRow>
                        <CCol sm="12">
                            <CInput :label="$t('longitude')" v-model="settings.longitude" :is-valid="genericValidator(settings.longitude) && errorValidator('Longitude')"></CInput>
                        </CCol>
                    </CRow>
                    <!-- Action button -->
                    <CCol class="d-flex justify-content-end mt-3">
                        <CRow sm="2" class="align-self-end">
                            <CSpinner v-if="submitting" variant="success" small></CSpinner>
                            <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                        </CRow>
                    </CCol>
                    <!-- Loading -->
                    <FormLoading v-if="loading"></FormLoading>
                </CCardBody>
            </CCard>
        </CCol>
        <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
    </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import FormLoading from '@/controls/FormLoading.vue'
import Settings from "@/classes/Settings";
import { genericValidator, errorValidator, deepClone } from "@/helpers/utils.js";
import { VueEditor } from "vue2-editor";

 export default {
    components: { ConfirmationPopUp, FormLoading, VueEditor },
    data () {
        return {
            settings: new Settings(),
            triedSubmit: false,
            submitting: false,     
            loading: true,
            updateError: null,
            resultMessage: '',
            showConfirmationPopup: false,
            confirmationMessage:"",
        }
    },

    computed:
    {
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output,
        }),
        errorOutput: function()
        {
            var result = [];

            if(this.alertType == 'alert-danger' && this.alertOutput && Array.isArray(this.alertOutput))
            {
                result = this.alertOutput.reduce(function(accum, currentVal) {
                accum[currentVal.key] = currentVal.value;
                    return accum;
                }, {});
            }

            // Validate password
            if(this.triedSubmit && (this.password || this.confirmPassword))
            {
                // It is necessary to validate the passwords
                var passwordPattern = /(?=.*[A-Za-z])(?=.*\d).{6,}$/g;

                if(this.password != this.confirmPassword)
                {
                    result['Password'] = this.$i18n.t("noMatchPassword");
                }
                else if(!this.password.match(passwordPattern))
                {
                    result['Password'] = this.$i18n.t("forbiddenPassword");
                }
            }

            return result;
        },
        ...mapState('settings', ['getSettingsOutput']),
        ...mapState('settings', ['putSettingsOutput']),
    },
    mounted()
    {
        this.getSettings();
    },
    methods:{
        ...mapActions('settings', ['getSettings']),
        ...mapActions('settings', ['putSettings']),
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
        },
        submitClicked()
        {
            this.submitting = true;
            this.triedSubmit = true;
            this.resultMessage = '';

            if(this.settings.isValid())
            {
                this.putSettings(this.settings);
            }
        },
        genericValidator,
        errorValidator,
    },
    watch:
    {
        alertType: function()
        {
            this.submitting = false;
        },
        alertOutput: function()
        {
            this.submitting = false;

            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        },
        getSettingsOutput: function(val)
        {
            this.loading = false;

            if(val && val.data)
            {
                this.settings = deepClone(new Settings, val.data);      
            }
        },
        putSettingsOutput: function(val) // Password update
        {
            if(val !== null)
            {
                if(val)
                {
                    this.resultMessage = this.$i18n.t("profileUpdateSuccess");
                }
                else
                {
                    this.resultMessage = this.$i18n.t("profileUpdateError");
                }

                this.showConfirmationPopup = true;
                this.submitting = false;
            }
        },
    }
 }
 
</script>

<style>

</style>